import React, { useCallback } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { endMeeting } from 'flow/actions/meeting-actions';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import Tooltip from 'flow/components/ui-components/Tooltip';

export const ButtonHangUp = () => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    const onClick = useCallback(() => {
        void dispatch(endMeeting());
    }, [dispatch]);

    return (
        <div
            className="flex flex-col items-center justify-center text-xs select-none"
            data-test-id={'meeting-hangup-button'}
        >
            <Tooltip
                label={i18next.t('videoconference.controlpanel.hang_up')}
                placement="top"
                tooltipClassName="text-white text-sm font-light py-2"
            >
                <button
                    type="button"
                    aria-label={i18next.t(
                        'videoconference.controlpanel.hang_up',
                    )}
                    className="bg-red focus-ring flex h-12 w-16 cursor-pointer items-center justify-center rounded-2xl border-none text-white hover:brightness-90"
                    onClick={onClick}
                >
                    <Icon
                        iconKey={'call_end_outlined'}
                        className="!h-6 !w-6 p-0"
                    />
                </button>
            </Tooltip>
        </div>
    );
};

export default ButtonHangUp;
